import { Component,Directive,HostListener,ElementRef,Renderer2,ViewChild, OnInit } from '@angular/core';
import { map, startWith, debounceTime } from 'rxjs/operators';
import { Breakpoints, BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { CarroService } from '../servicios/carroservice';
import { PeticionesService } from '../servicios/httpservice';
import { LocalStorageService, SessionStorageService } from 'ngx-webstorage';
import { HttpClient } from '@angular/common/http';
import { AlertifyService } from '../alertify.service';
import { MatPaginator, MatPaginatorIntl } from '@angular/material/paginator';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { PlantillafinService } from "../servicios/plantillafin.service"

@Component({
  selector: 'app-cotizador',
  templateUrl: './cotizador.component.html',
  styleUrls: ['./cotizador.component.css']
})
export class CotizadorComponent implements OnInit {
  public strNumCte: string;
  public objLinea: any;
  public arrayClientes: any;
  public bloques: any[][] = [];
  public elementosPorPagina: number = 0;
  public intTotalItems: number;
  public strConexion: string = "";
  public arrayAccesosMenu: any = [];
  public arrayAccesos: any;
  public strBuscarArticulo: string;
  public arrayCarritoArts: any = [];
  public ArrayNum: number = 0;
  public dblSubTotal = 0;
  public tagName: any;
  public strlinea: string = "";
  public arrayLineas: any = [];
  public arrayArtsporlinea: any = [];
  public arrayGrupos: any = []
  public objCliente: any = {
    strCliente: "",
    strNombre: "",
    strDireccion: "",
    ClienteSeleccionado: false,
    strSucursal: "",
    NombreSucursal: "",
    tipoSucursal: ""
  };
 
 
 
  /* public items: number = 16;
  public arrayPaginas: any[] = [];
  public currentPage: number = 1;
  public arrayExistentes: any = [];
  public strGrupoSelect: any = ''
  public arrayArts_all: any = [];
  @ViewChild(MatPaginator) paginator: MatPaginator;
  public cantProduct: number = 0;
  public strCheckMarca: string;
  public dispositivo: number;
  public arrayFilter: any[] = [];
  public strNombreCte: string;
  public strCategoSeleccionada: any = ''
  public strDireccionCte: string;
  public arrayCategoria: any;
  public arrayMarca: any;


  
  public arrayBusquedaArticulo: any;
  public arrayArticulos: any;
  public optionHid: string = "";

  public grupos: Record<string, any[]> = {};
 
  public objArt: any = {
    strArticulo: '',
    strDescripcion1: '',
    dblCantidad: 1,
    strOpcion: '',
    strNombreOpcion: '',
    dblPrecio: 0
  };
  public arrayPreciosArt: any = [
    {
      intPrecioLista: 0,
      intPrecio: 0,
      intPrecio2: 0,
      intPrecio3: 0,
      intPrecio4: 0
    }
  ];
  public Accesop4: any;
  public gruposUnicos = new Set<string>();
  public intPrecioLista: number = 0;
  public intPrecio: number = 0;
  public intPrecio2: number = 0;
  public intPrecio3: number = 0;
  public intPrecio4: number = 0;
  public intPrecioPlantilla: number = 0;
  public intPrecioPolitica: number = 0;
  public imagenUrl1: string;
  public imagenUrl2: string;
  public imagenUrl3: string;
  public imagenUrl4: string;
  public imagenUrl5: string;
  public isButtonFocused = false;
  public artOpc: boolean = true;
  public spinerCarrito: boolean = false





 */

  constructor(private servPlantilla: PlantillafinService, private router: Router, private renderer: Renderer2, public _alertify: AlertifyService,
    private el: ElementRef, private breakpointObserver: BreakpointObserver,
    private carroservice: CarroService, private localSt: LocalStorageService,
    private _httpService: PeticionesService, private http: HttpClient, private paginatorIntl: MatPaginatorIntl) {
      this.arrayClientes = [];
      this.paginatorIntl.itemsPerPageLabel = 'Elementos por página:';
      this.arrayAccesos = this.localSt.retrieve('arrayAccesos');
      this.arrayAccesosMenu = this.localSt.retrieve('arrayAccesosMenu');
      this.strConexion = this.localSt.retrieve('strConexion');
     }

     @HostListener('window:resize', ['$event'])
       onResize(event: any) {
         this.detectarTamanioPantalla();
         this.fnpaginarcarousel();
       }
  ngOnInit(): void {

    this.carroservice.intTotalItems$.subscribe((nuevoValor) => {
      this.intTotalItems = nuevoValor;
    });
    this.carroservice.arrayItems$.subscribe((nuevoValor) => {
      this.arrayCarritoArts = nuevoValor;
    });
    this.carroservice.dblSubTotalItems$.subscribe((nuevoValor) => {
      this.dblSubTotal = nuevoValor;
    });
    this.carroservice.ObjCliente$.subscribe((nuevoValor) => {
      this.objCliente = nuevoValor;
      if (nuevoValor.ClienteSeleccionado) {
        this.strNumCte = nuevoValor.strCliente;
      }
    });
    this.detectarTamanioPantalla();
    this.fnGetCategorias();
  }

  onKeyDown(event: KeyboardEvent): void {
    this.carroservice.deleteCarrito();
    this.strBuscarArticulo = '';
  /*   this.funArticulos(this.strBuscarArticulo); */
    if (event.key === 'Delete' || event.code === 'Delete' || event.key === 'Backspace' || event.code === 'Backspace') {
    }
  }
  fnBuscarCte(strNumCte: string) {
    this.objCliente = {
      strCliente: "",
      strNombre: "",
      strDireccion: "",
      ClienteSeleccionado: false,
      strNombreSucursal: "",
      intIDSucursal: "",
      strTipo: "",
      strAgente: "",
      strAlmacen: "",
      strClaveUsoCFDI: "",
      strCondicion: "",
      strDescripcionUsoCFDI: "",
      strInfopago: "",
      strInfopagoDescripcion: ""
    };
    let objPlantilla = { boolActive: false, intIDMovimientoVenta: 0 }
    this.servPlantilla.setPlantilla(objPlantilla);
    this.carroservice.setCte(this.objCliente);
    let cliente = {
      strAccion: "getCte",
      strCliente: strNumCte,
      strGerente: this.localSt.retrieve('strUsuario'), //strUsuario
      strTipoAcceso: this.localSt.retrieve('intIDRolAcceso'),//intIDRolAcceso
      strSucursal: this.localSt.retrieve('strSucursal'),//strSucursal
      strAgente: this.localSt.retrieve('strAgente'), //strAgente
      strConexion: this.strConexion
    };
    this._httpService.getCotizador(cliente).subscribe(
      result => {
        this.arrayClientes = result;
        let sucursales = []
        console.log(this.arrayClientes);
        this.arrayClientes.forEach(x => {
          if (x.strNombreSucursal != "") {
            sucursales.push(x);
          }
        });
      });
  }
  fnllenarInputs(i: number) {
    this.objCliente.strDireccion = this.arrayClientes[i].strDireccion;
    this.objCliente.strNombre = this.arrayClientes[i].strNombre;
    this.objCliente.strCliente = this.arrayClientes[i].strCliente;
    this.objCliente.strNombreSucursal = this.arrayClientes[i].strNombreSucursal;
    this.objCliente.intIDSucursal = this.arrayClientes[i].intIDSucursal;
    this.objCliente.strAgente = this.arrayClientes[i].strAgente;
    this.objCliente.ClienteSeleccionado = true;
    this.objCliente.strTipo = this.arrayClientes[i].strTipo;
    this.objCliente.strAlmacen = this.arrayClientes[i].strAlmacen;
    this.objCliente.strClaveUsoCFDI = this.arrayClientes[i].strClaveUsoCFDI;
    this.objCliente.strCondicion = this.arrayClientes[i].strCondicion;
    this.objCliente.strDescripcionUsoCFDI = this.arrayClientes[i].strDescripcionUsoCFDI;
    this.objCliente.strInfopago = this.arrayClientes[i].strInfopago;
    this.objCliente.strInfopagoDescripcion = this.arrayClientes[i].strInfopagoDescripcion;
    this.objCliente.strSucursal = this.arrayClientes[i].strSucursal;
    this.arrayClientes = [];
    this.carroservice.setCte(this.objCliente);
    this.carroservice.setModoPlantilla(false);
  }

  fnGetCategorias() {
    let listado = {
      strAccion: 'getCategorias',
      strConexion: this.strConexion
    };

    this._httpService.getCotizador(listado).subscribe(
      result => {
        this.arrayLineas = result;
        console.log(this.arrayLineas);
       /*  this.fnGetArticulos(result[0].strCategoria)*/
        this.fnpaginarcarousel();
      });
  }
  private detectarTamanioPantalla() {
    this.elementosPorPagina=0;
    const anchoPantalla = window.innerWidth;
    if (anchoPantalla <= 768) {
      this.elementosPorPagina = 3;
    } else {
      this.elementosPorPagina = 6;
    }
  }

  fnpaginarcarousel(){
    this.bloques=[];
    for (let i = 0; i < this.arrayLineas.length; i += this.elementosPorPagina) {
      this.bloques.push(this.arrayLineas.slice(i, i + this.elementosPorPagina));
    } 
  }


  /*   funArticulos(Articulo: string) {
    this.currentPage = 1;
  this.paginator.pageIndex = 0;
    if (Articulo === "" || Articulo === undefined) {
      this.arrayArticulos = [];
      this.arrayFilter = [];
      this.fnCalcular(this.dispositivo);
      this.funFiltrarCategoria();
      this.funfiltrarMarca();
    }
    else {
      this.strBuscarArticulo = Articulo;
      let articulo = {
        strAccion: "getArticulos",
        strArticuloBusqueda: this.strBuscarArticulo,
        strCliente: this.strNumCte,
        strConexion: this.strConexion,
        strCteFam: this.objCliente.strCteFam ? this.objCliente.strCteFam : ''
      };
      this._httpService.getCotizador(articulo).subscribe(
        result => {
          console.log(result)
          this.arrayArticulos = result;
          this.arrayFilter = result;
          this.arrayBusquedaArticulo = [];
          this.ArrayNum = this.arrayBusquedaArticulo.length;
          this.fnCalcular(this.dispositivo);
          this.funFiltrarCategoria();
          this.funfiltrarMarca();
        });
    }
  } */

  
/*   funFiltrarCategoria(){
    let resultado = new Array();
    resultado = this.arrayArticulos;
    this.arrayCategoria = resultado.filter(
      (thing, i, arr) => arr.findIndex(t => t.strCategoria === thing.strCategoria) === i);
    this.arrayCategoria.sort((a, b) => b.strCategoria - a.strCategoria);
  } */

/*   funfiltrarMarca(){
    let resultado = new Array();
    resultado = this.arrayArticulos;
    this.arrayMarca = resultado.filter(
      (thing, i, arr) => arr.findIndex(t => t.strLinea === thing.strLinea) === i);
    for (let i = 0; i < this.arrayMarca.length; i++) {
      this.arrayMarca[i].checkbx = false;
    }
    this.arrayMarca.sort((a, b) => a.strLinea - b.strLinea);
  } */


/*   fnCalcular(dispositivo: number) {

    let artFila = dispositivo == 2 ? 4 : 2;
    let tamFila = dispositivo == 2 ? 4.4 : 4.6;
    let filas = dispositivo == 2 ? this.arrayFilter.length / artFila <= 1 ? tamFila :
      this.arrayFilter.length > 4 && this.arrayFilter.length <= 8 ? tamFila * 2 :
        this.arrayFilter.length > 8 && this.arrayFilter.length <= 12 ? tamFila * 3 :
          this.arrayFilter.length > 12 && this.arrayFilter.length <= 16 ? tamFila * 4 :
            this.arrayFilter.length > 16 ? 18 : tamFila :
      this.arrayFilter.length <= 16 ?
        Math.ceil(this.arrayFilter.length / artFila) * tamFila : 36;
  this.card1[3].rows = Math.ceil(filas) + 1;
    this.card2[2].rows = 1.5  filas + 1; 
    this.fnPaginar();
    if (dispositivo == 2) {
      this.fnpaginarcarousel()
    } else {

    }

  } */


/*   fnPaginar() {
    let npaginas = Math.ceil(this.arrayFilter.length / this.items);
    npaginas = npaginas == 0 ? 1 : npaginas;
    this.arrayPaginas = [];
    for (let i = 1; i <= npaginas; i++) {
      this.arrayPaginas.push({ pagina: i })
      this.arrayFilter.forEach((element, index, arreglo) => {
        element.dblCalificacion = 3
        element.intTotalEstrellas = 2;
        if (index < this.items * i && index >= ((this.items * i) - this.items)) {
          element.pagina = i;
        }
      });
    }
  } */

/*   fnPaginator(pagina?: number, prev?: string) {
    if (prev == 'prev') {
      this.currentPage = this.currentPage - 1 > 1 ? this.currentPage - 1 : 1;
    }
    else if (prev == 'next') {
      this.currentPage = this.currentPage + 1 < this.arrayPaginas.length ? this.currentPage + 1 : this.arrayPaginas.length;
    }
    else {
      this.currentPage = pagina;
    }
  } */


  
  fnGetGrupos(categoria: any) {
    this.objLinea ={};
    this.objLinea = categoria;
    this.arrayGrupos =[];
   /*  console.log(categoria) */
    let grupos = {
      strAccion: 'getGrupos',
      strCategoria: categoria.strCategoria,
      strConexion: this.strConexion
    };
    this._httpService.getCotizador(grupos).subscribe(
      result => {
        console.log(result)
        this.arrayGrupos = result

       /*  this.arrayGrupos.forEach((element: any) => {
          const nombreGrupo = element.strGrupo;
          this.gruposUnicos.add(nombreGrupo);
    
          if (!this.grupos[nombreGrupo]) {
            this.grupos[nombreGrupo] = [];
          }
    
          this.grupos[nombreGrupo].push(element);
        }); */
      /*   this.fnGetArticulos(categoria.strCategoria); */
      });
      
    
  }


/*   fnGetArticulos(categoria: any) {
    this.arrayFilter = []
    this.arrayArts_all = [];
    this.strCategoSeleccionada = categoria
    let articulo = {
      strAccion: "getArticulo_Cat",
      strCategoria: categoria,
      strCliente: (this.objCliente.strCliente) ? this.objCliente.strCliente : '',
      strCteFam: (this.objCliente.strCteFam) ? this.objCliente.strCteFam : '',
      strConexion: this.strConexion
    };
    this._httpService.getCotizador(articulo).subscribe(
      result => {
        console.log(result)
        this.arrayArts_all = result;
        this.arrayFilter = result
        this.fnPaginar();
        this.fnCalcular(this.dispositivo);
      });
  } */

}
